<div *ngIf="values?.length > 1 || (!useButtonOneItem && values?.length === 1); else onlyContent"
     class="si-selector-custom {{styleClass}}"
     [class.si-selector-custom_hidden]="hideSelectorCustom">
  <si-selector [id]="id"
               [name]="name"
               [text]="text"
               [(model)]="model"
               [values]="values"
               styleClass="si-selector-custom_selector {{styleClassSelector}} {{showHighlight ? 'si-selector-custom_selector_selected-item' : ''}}"
               [hideLabel]="true"
               [openTop]="openTop"
               [showDropdownSearch]="false"
               [showClear]="false"
               [disabled]="disabled">
    <ng-template #selectedItem let-item let-outerContext>
      <div class="d-flex align-items-center si-selector-custom_item-content">
        <ng-container *ngIf="selectedItemCustom; else defaultSelectedItem">
          <ng-container *ngTemplateOutlet="selectedItemCustom; context: {$implicit: outerContext}"></ng-container>
        </ng-container>
        <ng-template #defaultSelectedItem>
          <ng-container *ngTemplateOutlet="content"></ng-container>
        </ng-template>
      </div>
    </ng-template>
    <ng-template #item let-outerContext let-item>
      <div (click)="onSelectItem(item)">
        <ng-container *ngIf="itemCustom; else defaultItem">
          <ng-container *ngTemplateOutlet="itemCustom; context: {$implicit: outerContext}"></ng-container>
        </ng-container>
        <ng-template #defaultItem>
          {{item.label}}
        </ng-template>
      </div>
    </ng-template>
  </si-selector>
</div>
<ng-template #onlyContent>
  <ng-container *ngIf="values?.length === 1; else emptyValues">
    <div class="si-selector-custom {{styleClass}}"
         [class.si-selector-custom_hidden]="hideSelectorCustom"
         (click)="onClickItem(values[0])">
      <ng-container *ngTemplateOutlet="content"></ng-container>
    </div>
  </ng-container>
  <ng-template #emptyValues>
    <div [hidden]="hideOnEmpty"
         class="si-selector-custom {{styleClass}} disabled"
         [class.si-selector-custom_hidden]="hideSelectorCustom">
      <ng-container *ngTemplateOutlet="content"></ng-container>
    </div>
  </ng-template>
</ng-template>
<ng-template #content>
  <ng-content></ng-content>
</ng-template>
